<template>
  <div class="flex items-center cellnametruncate">

    <!-- === AVATAR SECTION ===  -->
    <!-- === show image/picture ===  -->
      <vs-avatar v-if="customUserData && customUserData.picture && customUserData.picture !== '' && !square"  class="person-img rounded-full shadow-md block aggridcircleimg" 
          :src="customUserData.picture" />
      <img v-else-if="customUserData && customUserData.picture && customUserData.picture !== '' && square"
      :style="!details ? 'height: 40px; width: 40px; object-fit: contain;' : ''"
      :src="customUserData.picture"/>
      <vs-avatar v-else-if="picture && picture !== ''" class="person-img rounded-full shadow-md block aggridcircleimg"
          :src="picture" />

    <!-- === use colour_code ===  -->
      <vs-avatar
          v-else-if="customUserData && customUserData.colour_code"
          :text="customUserData.first_name.charAt(0).toUpperCase()
          + (customUserData.middle_name ? customUserData.middle_name.charAt(0).toUpperCase() : '')
          + customUserData.last_name.charAt(0).toUpperCase()"
          :color="customUserData.colour_code" text-color="white"
        />

    <!-- === use #000000 black colour_code ===  -->
      <vs-avatar
          v-else-if="customUserData && customUserData.first_name"
          :text="customUserData.first_name.charAt(0).toUpperCase()
          + (customUserData.middle_name ? customUserData.middle_name.charAt(0).toUpperCase() : '')
          +''+customUserData.last_name.charAt(0).toUpperCase()"
          color="#000000" text-color="white"
        />

    <!-- === if first_name is not found and customUserData.name is found ===  -->
      <vs-avatar
        v-else-if="colour_code"
        :text="first_name.charAt(0)
        + last_name.charAt(0)"
        :color="colour_code" text-color="white"
      />

      <vs-avatar
        v-else-if="name"
        :text="customUserData.name.charAt(0).toUpperCase()"
        color="#000000" text-color="white"
      />

    <!-- === show something if nothing is found ===  -->
      <vs-avatar v-else
        :text="name_not_found"
        color="#000000" text-color="white"
      />

    <!-- === NAME SECTION ===  -->
      <span v-if="showName && customUserData && customUserData.first_name" class="nametruncate">{{ customUserData.first_name }} {{ customUserData.middle_name }} {{ customUserData.last_name }}</span>
      <span v-else-if="showName && customUserData && customUserData.name" class="nametruncate">{{ customUserData.name }}</span>
      <span v-else-if="showName" class="nametruncate 333">N/A</span>

  </div>
</template>

<script>
import {imageValidationMixin} from '@/mixins/common/imageValidationMixin.js'

export default {
  name: 'CircleImageAvatar',
  mixins:[imageValidationMixin],

  data ()
  {
    return {
      first_name: '',
      middle_name: '',
      last_name: '',
      picture: '',
      colour_code: '',
      name_not_found: 'N/A',
      customUserData: {},
    }
  },

  props: {
    userData: {
      type: Object,
      required: false
    },
    showName: {
      type: Number,
      default: 1
    },
    square: {
      type: Boolean,
      default: false // Default to circular avatar
    },
    details: {
      type: Boolean,
      default: false // Default to circular avatar
    },
  },
  // added watcher because in /tasks-project?type=create multiple observers were not updating
  watch: {
    userData: {
      handler(newValue, oldValue) {
        this.customUserData = newValue;
      },
      immediate: true, // handle the initial value of userData
      deep: true // watch for changes in nested properties of userData
    }
  },
  methods: {
  
  },
  mounted(){
    if (typeof this.userData !== 'undefined') {
      // console.log("userData" , this.userData)
      this.customUserData = this.userData

    } else if(typeof this.params.userData !== 'undefined') {
      // console.log("this.params.userData" , this.params.userData)
      this.customUserData = this.params.userData
    }

    this.getComponentData();
  }

}
</script>